// TODO: If you make edits to this file you must deal with these ESLint rules
/*eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import styled from '@emotion/styled';

import { BREAKPOINTS, getColorTint, unit, unitTRBL } from '@zego/theme';

import Emphasis from '@zego/components/atoms/Emphasis';
import View from '@zego/components/atoms/View';
import PartnersBranding from '@zego/components/molecules/PartnersBranding';

import HighImpactSection from './HighImpactSection';

import ZegoCarsImage from '@zego/static/images/ZegoIsTrustedAriel.png';

export default function ZegoIsTrusted(): JSX.Element {
  return (
    <HighImpactSectionStyling
      imageUrl={ZegoCarsImage}
      imageAlt="Ariel photo with zego supergraphic"
      imageRatio={1.64}
      imagePosition="left"
    >
      <View
        css={{
          width: '100%',
          [BREAKPOINTS.medium]: { padding: '0 5px' },
        }}
      >
        <ContentStylingContainer>
          Zego is trusted by <Emphasis>tens of thousands</Emphasis> of
          vehicles, and supported by global
          <Emphasis> A-rated insurers and reinsurers</Emphasis>
        </ContentStylingContainer>

        <PartnersBranding />
      </View>
    </HighImpactSectionStyling>
  );
}
const ContentStylingContainer = styled.p({
  color: getColorTint('grey', 10),
  fontSize: 22,
  fontWeight: 700,
  textAlign: 'left',
  marginTop: unit(3.75),
  width: '100%',
  [BREAKPOINTS.smallOnly]: { marginTop: unit(1) },
  [BREAKPOINTS.medium]: { fontSize: 22, width: '100%' },
  [BREAKPOINTS.normal]: { fontSize: 32 },
  [BREAKPOINTS.large]: { width: '100%' },
});

const HighImpactSectionStyling = styled(HighImpactSection)({
  [BREAKPOINTS.medium]: { padding: unitTRBL(9, 0, 9, 0) },
  [BREAKPOINTS.large]: { padding: unitTRBL(10, 12, 10, 12) },
});
